import React, { createContext, useContext, useState, useCallback } from 'react';
import URL_FACTORY from '@/helpers/url-helper';
import axiosApiInstance from '@/api/shared/axios-instance';

const RecomendacionesContext = createContext();

export const useRecomendaciones = () => {
    const context = useContext(RecomendacionesContext);
    if (!context) {
        throw new Error('useRecomendaciones debe ser usado dentro de RecomendacionesProvider');
    }
    return context;
};

export const RecomendacionesProvider = ({ children }) => {
    const [recomendaciones, setRecomendaciones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchRecomendaciones = useCallback(async (teamIds, jornada) => {
        if (!teamIds || teamIds.length === 0 || !jornada) {
            setRecomendaciones([]);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const payload = {
                teamIds,
                jornada,
            };

            const response = await axiosApiInstance.post(URL_FACTORY.ObtenerRecomendacionesEquipo, payload);
            setRecomendaciones(response.data?.recomendaciones || []);
        } catch (err) {
            console.error('Error fetching recomendaciones:', err);
            setError(err.message);
            setRecomendaciones([]);
        } finally {
            setLoading(false);
        }
    }, []);

    const clearRecomendaciones = useCallback(() => {
        setRecomendaciones([]);
        setError(null);
    }, []);

    const value = {
        recomendaciones,
        loading,
        error,
        fetchRecomendaciones,
        clearRecomendaciones,
        hasRecomendaciones: recomendaciones.length > 0,
    };

    return <RecomendacionesContext.Provider value={value}>{children}</RecomendacionesContext.Provider>;
};
